// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__cQ2iS","upload":"Small_upload__qT6yG","imageWrap":"Small_imageWrap__3KvX9","removeBtn":"Small_removeBtn__vGbwM"};